import { Controller } from '@hotwired/stimulus'

// Compares classification use case ID with the editing use case ID
// and shows/hides the match indicator (checkmark)
export default class extends Controller {
  static targets = ['indicator']
  static values = { useCaseId: Number }

  connect() {
    this.checkMatch()
  }

  useCaseIdValueChanged() {
    this.checkMatch()
  }

  checkMatch() {
    if (!this.hasIndicatorTarget) return

    const editingUseCaseId = this.getEditingUseCaseId()
    const isMatch = editingUseCaseId && this.useCaseIdValue === editingUseCaseId

    if (isMatch) {
      this.indicatorTarget.classList.remove('hidden')
    } else {
      this.indicatorTarget.classList.add('hidden')
    }
  }

  getEditingUseCaseId() {
    // Look for the editing use case ID on the sandbox container
    const container = this.element.closest('[data-editing-use-case-id]')
    if (container) {
      const id = container.dataset.editingUseCaseId
      return id ? parseInt(id, 10) : null
    }
    return null
  }
}
